import React from 'react';
import PropTypes from 'prop-types';

import BlockSection from '~/components/wrappers/BlockSection';
import IllustrationsBackground from '~/components/wrappers/IllustrationsBackground';

import HeroContent from '~/components/hero/HeroContent';
import LargePhoto from '~/components/hero/LargePhoto';
import PhotoTextBox from '~/components/hero/PhotoTextBox';

import {
    GlobalBlockOptions,
    AcfAttributes,
    DefaultGlobalBlockOptions,
    DefaultAcfAttributes,
    AcfBackgroundColor,
    AcfLink
} from '~/utilities/propTypes';

const Hero = ({
    component = 'basic',
    backgroundColor = 'darkBlue',
    backgroundImage = null,
    backgroundImageType = 'image',
    lottieJson = null,
    graphicImage = '',
    padding = 'medium',
    contentPlacement = 'left',
    title,
    copy = '',
    ctasVariant = 'ctas',
    ctas = [],
    appLinks = [],
    globalBlockOptions = DefaultGlobalBlockOptions,
    attributes = DefaultAcfAttributes,
    children = null,
    ...rest
}) => {
    const componentMap = {
        basic: HeroContent,
        largePhoto: LargePhoto,
        photoTextBox: PhotoTextBox
    };

    const HeroComponent = componentMap[component];

    return (
        <BlockSection
            {...{
                backgroundColor,
                globalBlockOptions,
                attributes,
                padding
            }}
        >
            {graphicImage ? (
                <IllustrationsBackground backgroundGraphic={graphicImage} />
            ) : null}

            <HeroComponent
                {...{
                    backgroundImage,
                    backgroundImageType,
                    lottieJson,
                    backgroundColor,
                    title,
                    copy,
                    ctasVariant,
                    ctas,
                    appLinks,
                    contentPlacement,
                    children,
                    ...rest
                }}
            />
        </BlockSection>
    );
};

Hero.propTypes = {
    ...AcfBackgroundColor,
    component: PropTypes.string,
    backgroundImage: PropTypes.shape({}),
    backgroundImageType: PropTypes.oneOf(['image', 'animation']),
    lottieFile: PropTypes.shape({}),
    graphicImage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    padding: PropTypes.string,
    globalBlockOptions: GlobalBlockOptions,
    attributes: AcfAttributes,
    contentPlacement: PropTypes.oneOf(['left', 'center', 'right']),
    title: PropTypes.string.isRequired,
    copy: PropTypes.string,
    ctasVariant: PropTypes.string,
    ctas: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string,
            link: AcfLink
        })
    ),
    appLinks: PropTypes.arrayOf(
        PropTypes.shape({
            linkUrl: PropTypes.string,
            badge: PropTypes.shape({})
        })
    ),
    children: PropTypes.node
};

export default Hero;
